import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerCredits = async () => axios.get(Routes.CUSTOMER_CREDITS);

export const useCustomerCredits = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_CREDITS_QRY],
    queryFn: customerCredits,
  });
